import { getRoutePrefix } from '../utils';
import { initGlobalState, registerMicroApps, loadMicroApp, MicroApp } from 'qiankun';
import { FMicroProps, FPageConfig } from '../typings/index';

const microAppStateActions = initGlobalState({
  mainAppState: {},
});

export const register = (config: {
  entry: string;
  container?: string;
  props?: FMicroProps,
  activeRule: (location: Location) => boolean,
  loader: (loading: boolean) => void
}, lifeCys?: any) => {
  registerMicroApps([
    {
      name: 'smart-contact-cms-index',
      entry: config.entry, // devserver 类似转发
      container: config.container || '#app',
      props: config.props,
      activeRule: config.activeRule,
      loader: config.loader,
    },
  ], lifeCys);
}

export const update = (value: {
  mainAppState: any,
  mainAppCommit: any,
  mainAppDispatch: any
}) => {
  microAppStateActions.setGlobalState(value);
};

export const load = (config: {
  entry: string;
  container?: string;
  props: FMicroProps,
}) => {
  // TODO 对路由进行hash检测
  const { props: { pageInfo, useNativeRoute } } = config;
  const hash = (pageInfo as FPageConfig).path.startsWith('/#') ? (pageInfo as FPageConfig).path.slice(2) : (pageInfo as FPageConfig).path;
  if (window.location.hash !== hash) {
    if (useNativeRoute === 0) {
      // 采用PageInfo的路径
      window.location.hash = hash;
    } else if (useNativeRoute === 1) {
      // 采用前缀路径模式
      const routerPrefix = getRoutePrefix(pageInfo as any);
      window.location.hash = `${routerPrefix?.length > 20 ? '' : routerPrefix}${hash}`;
    } else {
      // 不做任何路径修复，应用渲染模式
    }
  }
  const instance: MicroApp = loadMicroApp(
    {
      name: 'smart-contact-cms-index',
      entry: config.entry, // devserver 类似转发
      container: config.container || '#app',
      props: config.props,
    },
    {
      singular: true,
    }
  );
  return instance;
}

